// Copyright (c) 2025 Signal from Noise, Inc. All rights reserved.
//
// This software is the confidential and proprietary information of
// Signal from Noise, Inc. You shall not disclose such Confidential Information
// and shall use it only in accordance with the terms of a separate license
// agreement entered into with Signal from Noise, Inc.
//
// Authors: /AUTHORS

// DO NOT EDIT.
// Code generated in 2025 by '/pkg/go/domains/ai/generator/typescript_client_generator.go'
// This file is intended for version control.


/**
 * modelDisplayName returns the display name for the provided model. This function is generated.
 * @param model the model name
 **/
export const modelDisplayName = (model: string): string => {
    switch (model) {
   case 'claude-3-5-sonnet-20241022': { return 'Claude 3.5 Sonnet' }
   case 'claude-3-7-sonnet-latest': { return 'Claude 3.7 Sonnet' }
   case 'deepseek-r1-distill-llama-70b': { return 'DeepSeek R1 Distill Llama 70B' }
   case 'gemini-2.0-flash-001': { return 'Gemini 2.0 Flash' }
   case 'gemini-2.5-pro-exp-03-25': { return 'Gemini 2.5 Pro' }
   case 'gpt-4.1-2025-04-14': { return 'GPT-4.1' }
   case 'gpt-4.1-mini-2025-04-14': { return 'GPT-4.1 Mini' }
   case 'gpt-4.1-nano-2025-04-14': { return 'GPT-4.1 Nano' }
   case 'llama-3.3-70b-versatile': { return 'Llama 3.3 70B' }
   case 'meta-llama/llama-4-scout-17b-16e-instruct': { return 'Llama 4 Scout' }
   case 'o3': { return 'O3' }
   case 'o4-mini': { return 'O4 Mini' }
   case 'storytell-curated-2': { return 'Storytell' }
   case 'storytell-programmatic-1': { return 'Storytell' }
   default:
    return model;
  }
}

/**
 * modelVendor returns the vendor for the provided model. This function is generated.
 * @param model the model name
 **/
export const modelVendor = (model: string): string => {
    switch (model) {
   case 'claude-3-5-sonnet-20241022':
    return 'anthropic';
   case 'claude-3-7-sonnet-latest':
    return 'anthropic';
   case 'deepseek-r1-distill-llama-70b':
    return 'deepseek';
   case 'gemini-2.0-flash-001':
    return 'google';
   case 'gemini-2.5-pro-exp-03-25':
    return 'google';
   case 'gpt-4.1-2025-04-14':
    return 'openai';
   case 'gpt-4.1-mini-2025-04-14':
    return 'openai';
   case 'gpt-4.1-nano-2025-04-14':
    return 'openai';
   case 'llama-3.3-70b-versatile':
    return 'meta';
   case 'meta-llama/llama-4-scout-17b-16e-instruct':
    return 'meta';
   case 'o3':
    return 'openai';
   case 'o4-mini':
    return 'openai';
   case 'storytell-curated-2':
    return 'storytell';
   case 'storytell-programmatic-1':
    return 'storytell';
   default:
    return 'unknown';
  }
}
